import React from 'react'
import Header from '../Components/Header'
import Footer from '../Components/Footer'
import News from '../Pages/News'

function NewsLayout() {
  return (
    <>
    <Header />
     <News />
    <Footer />
    </>
  )
}

export default NewsLayout